import { createIsomorphicFn } from '@tanstack/react-start';

import { i18nClientStore } from '~lexibird-marketing/i18n-client-store';
import { i18nStorage } from '~lexibird-marketing/i18n-storage';
import type { I18nContext } from '~lexibird-marketing/types/i18n-context';

/**
 * The locale and catalogue in play, reachable without prop drilling — route
 * `head` functions build their titles from messages, and they run outside
 * React.
 *
 * On the server that is the request's scope (see ~lexibird-marketing/server);
 * on the client it is the catalogue ~lexibird-marketing/client loads before
 * hydrating, which is why this can stay synchronous. The language switcher reloads the page
 * rather than swapping the catalogue in place, so the client value never goes
 * stale.
 */
const getI18nContext = createIsomorphicFn()
  .server((): I18nContext | undefined => i18nStorage.getStore())
  .client((): I18nContext | undefined => i18nClientStore.context);

export const requireI18nContext = (): I18nContext => {
  const context = getI18nContext();
  if (!context) {
    throw new Error(
      'No i18n context: the request middleware did not run, or the client entry did not load the catalogue.',
    );
  }
  return context;
};
